import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import { selectGlobalIssueCategoriesListItems } from "../../../../redux/global-issue-categories/selector";
import { globalIssueCategories } from "../../../../redux/global-issue-categories/action";
import { deepCopy } from "../../../../common/services/common.service";
import EditableTable from "../../../../common/components/table-manager/editable-table";

const GlobalIssueCategories = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const globalIssueCategoriesListItems = useSelector(selectGlobalIssueCategoriesListItems)

    const [columnData, setColumnData] = useState([
        { label: "Platform", field: "Platform", selectAColumnList: true, visible: true, type: "string", sortedBy: false, filterType: 'text', },
        { label: "Name", field: "Name", visible: true, isEdit: true, selectAColumnList: true, type: "string", sortedBy: false, searchField: 'Name', filter: true, filterType: 'text', },
        { label: "Parent Issue Category Name", field: "ParentIssueCategoryName", visible: true, selectAColumnList: true, type: "string", sortedBy: false, filterType: 'text', },
        { label: "Sub Issue Category", field: "IsSubIssueCategory", visible: true, selectAColumnList: true, type: "boolean", sortedBy: false, filterType: 'boolean', },
        { label: "Active", field: "IsActive", visible: true, selectAColumnList: true, type: "boolean", sortedBy: false, filterType: 'boolean', },
        { label: "Display Order", field: "DisplayOrder", visible: true, selectAColumnList: true, type: "number", sortedBy: false },
    ]);

    const fetchIssueCatagories = async () => {
        await dispatch(globalIssueCategories.resetAction({ actionType: 'list' }))
        await dispatch(globalIssueCategories.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories/dbn-fetch`,
            entity: 'globalIssueCategories',
            jsonData: {
                "Context": {},
                "Records": [{}],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalIssueCategoryId",
                    "SortOrder": "desc",
                }
            }
        }))
    }

    useEffect(() => {
        fetchIssueCatagories();
    }, [pageData, pageSize])

    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add Issue Catagory</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAdd(),
        },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.GlobalIssueCategoryId}`)
    }

    const handleReloadData = () => {
        fetchIssueCatagories();
    }

    const handleDelete = async (data: any) => {
        await dispatch(globalIssueCategories.resetAction({ actionType: 'delete' }))
        await dispatch(globalIssueCategories.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories/delete`,
            entity: 'globalIssueCategories',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.GlobalIssueCategoryId
                    }
                ]
            }
        })).then(() => {
            fetchIssueCatagories();
        });
    }

    const handleSearch = async (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        await dispatch(globalIssueCategories.resetAction({ actionType: 'list' }))
        await dispatch(globalIssueCategories.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-issue-categories/dbn-fetch`,
            entity: 'globalIssueCategories',
            jsonData: {
                "Context": {},
                "Records": [{}],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "GlobalIssueCategoryId",
                    "SortOrder": "desc",
                    "Searches": searchCriteria,
                }
            }
        }))
    }

    return (
        <div className="h-screen bg-gray-100 flex flex-col">
            {globalIssueCategoriesListItems?.isLoading ? (
                <PageLoader />
            ) : (
                <div className="p-4">
                    <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
                        <EditableTable
                            columnData={columnData}
                            rowData={deepCopy(globalIssueCategoriesListItems?.result?.items) || []}
                            setPageData={setPageData}
                            setPageSize={setPageSize}
                            paginationData={globalIssueCategoriesListItems?.result?.pagination}
                            enableFilter={true}
                            onSearch={handleSearch}
                            showBulkupdate={false}
                            isEditable={false}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                            additionButtons={additionButtons}
                            headingName="Global Issue Categories"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GlobalIssueCategories;


